import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import { CheckCircle2 } from 'lucide-react'
import { useLanguage } from '../../hooks/useLanguage'

export default function ContactConfirmed() {
  const { language } = useLanguage()
  const isEnglish = language === 'en'
  const title = isEnglish ? 'Message received | GMS Tech' : 'Mensagem recebida | GMS Tech'
  const description = isEnglish
    ? 'Your message was received. We will reply shortly.'
    : 'Sua mensagem foi recebida. Em breve entraremos em contato.'
  const url = isEnglish ? 'https://gmstech.dev/en/contact-confirmed' : 'https://gmstech.dev/contact-confirmed'

  return (
    <div className="flex min-h-screen items-center justify-center bg-white text-gms-ink">
      <Helmet>
        <html lang={isEnglish ? 'en' : 'pt-BR'} />
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={url} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={url} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Helmet>
      <div className="mx-auto max-w-xl px-6 py-24 text-center">
        <CheckCircle2 className="mx-auto mb-6 h-10 w-10 text-gms-accent" strokeWidth={1.75} />
        <h1 className="text-[clamp(32px,4vw,48px)] font-semibold leading-none tracking-[-0.04em]">
          {isEnglish ? 'Thanks for reaching out!' : 'Obrigado pelo contato!'}
        </h1>
        <p className="mx-auto mt-4 max-w-md text-lg leading-[1.55] text-gms-muted">
          {isEnglish
            ? 'Your message was received. We will get back to you within the same business day.'
            : 'Sua mensagem foi recebida. Retornaremos no mesmo dia útil.'}
        </p>
        <div className="mt-8">
          <Link
            className="gms-btn inline-flex min-h-[52px] items-center rounded-full bg-gms-ink px-6 font-semibold text-white hover:text-white"
            to={isEnglish ? '/en' : '/'}
          >
            {isEnglish ? 'Back to home' : 'Voltar para o início'}
          </Link>
        </div>
      </div>
    </div>
  )
}
